class GoogleMapsLoader {

    static loadGoogleMaps() {

        return new Promise(function(res, rej) {
            const apiKey = window.googleMapsApiKey;
    
            let $script = document.createElement('script');
            
            $script.onload = () => {
                _log('successful added google maps script');
                res();
            };
            
            $script.onerror = (e) => {
                console.log(e);
                console.warn('error adding google maps script');
                rej()
            };
            
            $script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey;
            document.getElementsByTagName('head')[0].appendChild($script);
        })

    }

}

export default GoogleMapsLoader;
